import axios from 'axios'
import * as MT from '../mutation-types'

const R = require('ramda')

export const state = {
  /* API URLS */
  apiUrls: {
    domain: process.env.VUE_APP_API_URL,
    auswertung: 'evaluationinprogress',
    office: 'officedata'
  },
  token: 0,
  loading: false,
  loggedIn: false,
  error: null,
  errorTitle: null,
  init: {
    finished: false,
    step: 1
  },
  office: {
    tablePos: 0,
    lastGame: 'Spielfrei',
    nextGame: { isPokal: false, text: '' },
    heimRekord: 0,
    auswRekord: 0,
    giro: 0,
    sponsorTP: 0,
    sponsor: 0,
    players: '',
    kraft: 0,
    motivation: 0,
    technik: 0,
    kondition: 0,
    heimIndex: 0,
    auswIndex: 0,
    avgheimIndex: 0,
    avgauswIndex: 0,
    maxheimIndex: 0,
    maxauswIndex: 0,
    ereignisse: []
  },
  matchEvaluationInProgress: false,
  chat: false,
  chatMessage: [],
  newMessageCounter: 0,
  isConnected: false,
  snackbar: false,
  snackbarText: '',
  pageLoading: false,
  showPageLoading: true,
  cacheTimeout: 60 * 60 * 2, // time since the cache run out in seconds (2 stunden)
  generateRandomInt: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }
}

export const mutations = {
  [MT.ROOT_SET_OFFICE_DATA] (state, value) {
    state.office = value
  },
  [MT.CHAT_SEND_MESSAGE] (state, value) {
    // console.log(value)
  },
  [MT.CHAT_SET_CONNECTION_STATUS] (state, status) {
    state.isConnected = true
  },
  [MT.CHAT_SET_NEW_MESSAGE] (state, message) {
    const messages = state.chatMessage
    messages.push(message)
    state.chatMessage = messages
    state.newMessageCounter += 1
  },
  [MT.CHAT_RESET_NEW_MESSAGE] (state) {
    state.chatMessage = []
  },
  [MT.CHAT_SET_NEW_MESSAGE_COUNTER] (state) {
    state.newMessageCounter += 1
  },
  [MT.CHAT_RESET_NEW_MESSAGE_COUNTER] (state) {
    state.newMessageCounter = 0
  },
  [MT.ROOT_LOGOUT] (state) {
    state.token = null
    state.loggedIn = false
    state.init = { finished: false, step: 1 }
  },
  [MT.ROOT_SET_TOKEN] (state, token) {
    state.token = token
  },
  [MT.ROOT_SET_INIT] (state, val) {
    if (val.finished) {
      state.init = false
    } else {
      state.init.step = val.step
    }
  },
  [MT.ROOT_SET_LOGGED_IN] (state) {
    state.loggedIn = true
  },
  [MT.ROOT_LOADING] (state, value) {
    state.loading = value
  },
  [MT.ROOT_PAGE_LOADING] (state, value) {
    state.pageLoading = value
  },
  [MT.ROOT_SET_ERROR] (state, error) {
    if (error.error) {
      state.error = error.error
    } else {
      if (error.message) {
        state.error = error.message
      }
    }

    if (error.title) {
      state.errorTitle = error.title
    }
  },
  [MT.ROOT_CLEAR_ERROR] (state) {
    state.error = null
    state.errorTitle = null
    state.showVerifyLink = false
  },
  [MT.ROOT_SET_SNACKBAR] (state, text) {
    state.snackbarText = text
    state.snackbar = true
  },
  [MT.ROOT_CLEAR_SNACKBAR] (state) {
    state.snackbarText = ''
    state.snackbar = false
  },
  [MT.ROOT_SET_MATCH_EVALUATION] (state, value) {
    state.matchEvaluationInProgress = value
  }
}

export const getters = {
  // evaluation URL
  evaluationUrl: (state) => {
    return state.apiUrls.domain + state.apiUrls.auswertung
  },
  // office URL
  officeUrl: (state) => {
    return state.apiUrls.domain + state.apiUrls.office
  }
}

export const actions = {
  // get office data
  async getOfficeData ({ commit, dispatch, getters }) {
    // set transport options
    const transportOptions = {
      data: { fakeData: true },
      url: getters.officeUrl
    }
    const response = await dispatch('sendDataToServer', transportOptions, { root: true })
    let ret = true
    if (response.success) {
      commit(MT.ROOT_SET_OFFICE_DATA, response.data.office)
    } else {
      ret = false
    }

    return ret
  },
  // check if auswertung is running
  async matchEvaluationInProgress ({ state, commit, dispatch, getters }) {
    // set transport options
    const transportOptions = {
      data: { fakeData: true },
      method: 'get',
      url: getters.evaluationUrl,
      withoutAuth: true,
      hideLoading: true
    }
    const response = await dispatch('sendDataToServer', transportOptions, { root: true })
    let ret = true
    if (response.success) {
      commit(MT.ROOT_SET_MATCH_EVALUATION, response.data.auswertung)
      // check if auswertung is an and user is logged in
      if (response.data.auswertung && state.loggedIn) {
        commit(MT.ROOT_SET_SNACKBAR, 'Auswertung hat begonnen, Du wirst jetzt ausgeloggt.')
        dispatch('logout')
      }
    } else {
      ret = false
    }
    return ret
  },
  // logout user and clear ale states
  async logout ({ state, commit }) {
    await commit('moneyStore/MONEY_RESET', null, { root: true })
    await commit('changelogStore/CHANGELOG_RESET', null, { root: true })
    await commit('fahrzeugStore/FAHRZEUG_RESET', null, { root: true })
    await commit('kegelbahnStore/KEGELBAHN_RESET', null, { root: true })
    await commit('managerStore/MANAGER_RESET', null, { root: true })
    await commit('teamStore/TEAM_RESET', null, { root: true })
    await commit('loginRegisterStore/AUTH_RESET', null, { root: true })
    await commit(MT.ROOT_CLEAR_SNACKBAR)
    await commit(MT.ROOT_CLEAR_ERROR)
    await commit(MT.ROOT_LOGOUT)
    await commit(MT.CHAT_RESET_NEW_MESSAGE_COUNTER)
    await commit(MT.CHAT_RESET_NEW_MESSAGE)
    window.sessionStorage.removeItem(process.env.VUE_APP_KMO_SESSION_NAME)
    window.sessionStorage.clear()
    window.location.href = '/logout'
  },
  // method to send all new data from server to stores
  refreshUserData ({ commit }, userData) {

  },
  catchErrorHandling ({ commit, dispatch }, error) {
    // todo get data if expired then commit logout go to login
    if (error && error.code && (
      error.code === 'E_JWT_TOKEN_EXPIRED' ||
      error.code === 'E_INVALID_JWT_TOKEN'
    )) {
      commit(MT.ROOT_SET_SNACKBAR, 'Token abgelaufen, bitte erneut einloggen.')

      dispatch('logout')
    }
    const errorData = {
      message: 'Daten konnten nicht übermittelt werden oder ein Serverfehler liegt vor. Bitte probieren Sie es später noch einmal.'
    }

    if (error && error.status > 200) {
      if (error.status === 500) {
        errorData.message = 'Interner Server Fehler! Backend ist Feherhaft oder der Server spinnt.'
      } else {
        errorData.message = 'Fehler auf dem Server #Status: ' + error.status + '#Name: ' + error.name + '#error: ' + error.message
      }
      errorData.title = 'Serverfehler'
    } else {
      // check for many message formats
      if (error.message) {
        errorData.message = error.message
      }
      if (error.data && error.data.message) {
        errorData.message = error.message
      }
      if (error.response && error.response.data && error.response.data.message) {
        errorData.message = error.response.data.message
      }
    }

    commit(MT.ROOT_SET_ERROR, errorData)
    commit(MT.ROOT_SET_SNACKBAR, errorData.message)

    commit(MT.ROOT_LOADING, false)
    commit(MT.ROOT_PAGE_LOADING, false)
  },
  /**
    Send Data to Server

    transportData = {
      url: getters.saveAufstellungUrl,
      data: aufstellung,
      method: get,
      withoutAuth: true
    }
   */
  async sendDataToServer ({ state, commit, getters, dispatch }, transportData) {
    const axiosOptions = {
      method: 'post',
      url: '',
      data: null,
      responseType: 'json',
      withCredentials: true,
      timeout: 60000,
      // `headers` are custom headers to be sent
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: 'Bearer ' + state.token
      }
    }
    // check if propertie is set and negate result
    const checkProp = R.complement(R.has(R.__, transportData))
    // check if propertie is empty
    const isValueEmpty = R.pipe(R.prop(R.__, transportData), R.isEmpty)
    // combine both mehtods
    const checkIsEmpty = R.anyPass([checkProp, isValueEmpty])

    // check url and data
    if (checkIsEmpty('url') || checkIsEmpty('data')) {
      await commit(MT.ROOT_SET_SNACKBAR, 'URL oder Daten fehlen, kann keine Daten senden')
      return { success: false }
    }
    axiosOptions.url = transportData.url
    axiosOptions.data = transportData.data

    // check send method post is default / set get if set
    if (!checkIsEmpty('method')) {
      axiosOptions.method = transportData.method
    }

    // check withoutAuth
    if (!checkIsEmpty('withoutAuth')) {
      axiosOptions.headers = {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    let loading = true
    if (!checkIsEmpty('hideLoading')) {
      loading = false
    }
    if (loading) {
      commit(MT.ROOT_LOADING, true)
      commit(MT.ROOT_PAGE_LOADING, true)
    }
    commit(MT.ROOT_CLEAR_ERROR, null)

    const returnValue = {
      success: false
    }
    try {
      // try to send data
      // console.log(axiosOptions)
      const response = await axios(axiosOptions)
      if (response.status === 200) {
        if (response.data.error) {
          commit(MT.ROOT_SET_ERROR, response.data)
          // check for login option
          if (response.data.showVerifyLink) {
            commit('loginRegisterStore/AUTH_SHOW_VERIFY_LINK', true, { root: true })
          }
          await dispatch('catchErrorHandling', { response: response })
        } else {
          returnValue.success = true
          returnValue.data = response.data
        }
      } else {
        commit(MT.ROOT_SET_SNACKBAR, 'Fehler auf dem Server. Backend. Status: ' + response.status)
      }
    } catch (error) {
      let bugError = error
      if (error.response && error.response.data) {
        bugError = error.response.data
      }
      await dispatch('catchErrorHandling', bugError)
    }

    commit(MT.ROOT_LOADING, false)
    commit(MT.ROOT_PAGE_LOADING, false)

    return returnValue
  }
}
